import axios from 'axios';

axios.defaults.timeout = 15*1000;//60s
axios.defaults.retry = 5;
axios.defaults.retryDelay = 2000;
// axios.defaults.baseURL = 'http://192.168.1.122:8888';
axios.defaults.baseURL = '/';

// // http request 拦截器
// axios.interceptors.request.use(
//   config => {
//     config.headers = {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(err)
//   }
// )

// 相应拦截器即异常处理
axios.interceptors.response.use(response => {
  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        console.log('错误请求');
        break;
      case 401:
        console.log('未授权，请重新登录')
        break;
      case 403:
        console.log('拒绝访问')
        break;
      case 404:
        console.log('请求错误,未找到该资源')
        break;
      case 405:
        console.log('请求方法未允许')
        break;
      case 408:
        console.log('请求超时')
        break;
      case 500:
        console.log('服务器端出错')
        break;
      case 501:
        console.log('网络未实现')
        break;
      case 502:
        console.log('网络错误')
        break;
      case 503:
        console.log('服务不可用')
        break;
      case 504:
        console.log('网络超时')
        break;
      case 505:
        console.log('http版本不支持该请求')
        break;
      default:
        console.log(`连接错误${err.response.status}`)
    }
  } else {
    console.log('连接到服务期失败')
  }
})

/**
|--------------------------------------------------
| @method get方法
|--------------------------------------------------
*/
export function Get(url,params={}){
  return new Promise((resolve,reject)=>{
    axios.get(url,{
      params     
    }).then(response=>{
      resolve(response.data)
    }).catch(err=>{
      reject(err)
    })
  })
}

/**
|--------------------------------------------------
| @method post 请求
|--------------------------------------------------
*/
export function Post(url,data,timeout){
  return new Promise((resolve,reject)=>{
    if(timeout){//设置超时时间
      axios.post(url,data,timeout).then(response=>{
        resolve(response)
      },err=>{
        reject(err)
      })
    }else{
      axios.post(url,data).then(response=>{
        resolve(response)
      },err=>{
        reject(err)
      })
    }

  })
}

/**
|--------------------------------------------------
| @method postJson 请求
|--------------------------------------------------
*/
export function postJson(url,data){
  return new Promise((resolve,reject)=>{
    axios({
      method:'post',
      url,
      data,
      'Content-Type': 'application/json'
    }).then(response=>{
      resolve(response)
    },err=>{
      reject(err)
    })
  })
}


// WEBPACK FOOTER //
// ./src/utils/httpServer.js